import { Timestamp } from '@bufbuild/protobuf/wkt';
import {
  Device,
  User,
} from '@wavingroup/iot-core/gen/ts/wavin/ignite/v1/user_pb';
import { GlobalPermissionType } from '@wavingroup/iot-core/gen/ts/wavin/kleos/v1/global_permission_pb';
import { GlobalPermissionModel } from '~/shared/models/globalPermission/GlobalPermissionModel';
import { RoleModel } from '~/shared/models/role/RoleModel';
import { isAssignableKleosPermission } from '~/shared/models/role/kleosRoleMapping';

export class UserModel {
  readonly name: string;

  readonly devices: Device[];

  readonly termsAcceptedVersion?: string;

  readonly languageCode?: string;

  readonly roles: RoleModel[];

  readonly globalPermissions: GlobalPermissionModel[];

  readonly email: string;

  readonly installerAgreementTime?: Timestamp;

  constructor(user: User, globalPermissions: GlobalPermissionType[] = []) {
    this.name = user.name;
    this.devices = user.devices;
    this.termsAcceptedVersion = user.termsAcceptedVersion;
    this.installerAgreementTime = user.installerAgreementTime;
    this.languageCode = user.languageCode;
    this.roles = user.roles.map((role) => new RoleModel(role));
    this.globalPermissions = globalPermissions
      .filter(isAssignableKleosPermission)
      .map((permission) => new GlobalPermissionModel(permission));
    this.email = user.email;
  }
}
